$ = require 'jquery'
{ track } = require '@trello/analytics'
{ Analytics } = require '@trello/atlassian-analytics'

Util = require 'app/scripts/lib/util'
Confirm = require 'app/scripts/views/lib/confirm'

module.exports.openUnsubscribe = (e) ->
  Util.stop(e)

  Confirm.toggle 'unwatch',
    elem: $(e.target).closest('.js-board-header-subscribed')[0]
    model: @model
    confirmBtnClass: 'negate'
    fxConfirm: (e) =>
      track("Board Header", "Unsubscribe")
      if @sendGASEvent
        Analytics.sendTrackEvent
          action: 'unsubscribed'
          actionSubject: 'board'
          source: 'boardScreen'
          containers:
            board:
              id: @model.id
      @model.subscribe(false)
  return
